import React from 'react';
import ConfirmationPopup from './ConfirmationPopup';
import fileDeleteIcon from '../../../icons/icon-file-delete.png';

const DeleteFileConfirmation = ({
  onClose,
  onConfirm,
  fileName,
}) => {
  return (
    <ConfirmationPopup
      onClose={onClose}
      onConfirm={onConfirm}
      icon={fileDeleteIcon}
      iconAlt="Delete file"
      title="Delete these files?"
      description="Deleted files go to the trash bin and will be stored there for 30 days."
    />
  );
};

export default DeleteFileConfirmation;

